import request from '@/utils/request'

export function qbShareFile(fileId, courseId) {
  return request({ url: '/amc/qb/share/file', method: 'post', params: { fileId, courseId } })
}

export function qbShareList(courseId) {
  return request({ url: '/amc/qb/share/list', method: 'get', params: { courseId } })
}
